<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">安全巡查活动列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="活动状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.activityStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="巡查对象">
          <el-select v-model="formInline.target_id" clearable filterable :placeholder="`请选择`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name || item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡查人员">
          <el-select v-model="formInline.member_id" clearable filterable :loading="loading" remote
            :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">创建活动</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="活动名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="status_text" label="活动状态" width="150"></custom-table-column>
        <custom-table-column prop="target_name" label="巡查对象" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="member_name" label="巡查人员" width="200px">
          <template slot-scope="scope" v-if="scope.row.members">
            <el-tag v-for="(item, index) in scope.row.members" :key="index">{{ item.member_name }}</el-tag>
          </template>
        </custom-table-column>
        <custom-table-column prop="check_date" label="巡查日期" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 0">
              <el-button @click="handleEditNew(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
            <el-button v-if="scope.row.status == 2" @click="handleDetail(scope.row)" type="text"
              size="small">查看结果</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="活动名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="巡查日期" prop="check_date">
          <el-date-picker type="date" placeholder="请选择" value-format="yyyy-MM-dd" v-model="ruleForm.check_date"
            style="width: 216px;" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="巡查对象" prop="target_id">
          <!-- <el-select v-model="ruleForm.target_id" clearable multiple filterable :placeholder="`请选择`"
            style="width: 216px;">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select> -->
          <el-cascader v-model="ruleForm.target_id" filterable ref="cascader" :props="propsT" style="width:532px;"
            clearable :options="$store.state.trainRoomsTree"></el-cascader>
        </el-form-item>
        <el-form-item label="巡查人员" prop="member_ids">
          <el-select v-model="ruleForm.member_ids" clearable style="width:216px;" multiple filterable reserve-keyword
            :loading="loading" remote :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡查内容" prop="content">
          <el-input type="textarea" v-model="ruleForm.content" :rows="5" placeholder="请输入"
            style="width:532px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="活动通知" prop="active_notice">
          <el-radio-group v-model="ruleForm.active_notice" style="width:216px;">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="查看结果" :visible.sync="detailDialogVisible" width="846px">
      <SafeCheckRusult :rowObj="rowObj" />
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import SafeCheckRusult from "./components/safeCheckRusult";

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        name: '',
        status: '',
        target_id: '',
        member_id: '',
      },
      rowObj: {},
      users: [],
      propsT: { multiple: true, value: 'id', label: 'name', emitPath: false },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - 24 * 60 * 60 * 1000);
        },
      },
      detailDialogVisible: false,
      ruleForm: {
        name: '',
        check_date: '',
        target_id: '',
        member_ids: '',
        content: '',
      },
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'change' }],
        check_date: [{ required: true, message: '请选择', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择', trigger: 'change' }],
        target_id: [{ required: true, message: '请选择', trigger: 'change' }],
        member_ids: [{ required: true, message: '请选择', trigger: 'change' }],
        content: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
    };
  },
  components: {
    SafeCheckRusult
  },
  created() {
    this.$store.dispatch('getTarinMentTree');
    
  },
  mounted() {
  },
  methods: {
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/safe-check-activity/delete/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },

    handleDetail(row) {
      this.detailDialogVisible = true
      if (row.members && row.members.length > 0) {
        row.member_names = row.members ? row.members.map(item => item.member_name).join(',') : ''
      }
      this.rowObj = row
    },
    handleEditNew(row, extraKeys = ['id']) {
      this.type = 'edit'
      this.title = "编辑"
      this.ruleForm = this.assignFormObj(this.ruleForm, row, extraKeys)
      this.ruleForm.target_id = row.target_id ? row.target_id.split(',') : []
      // this.remoteMethod(row.member_name, true)

      if (row.members && row.members.length > 0) {
        this.ruleForm.member_ids = row.members ? row.members.map(item => item.member_id) : []
        row.members.map(item => {
          if (JSON.stringify(this.users).indexOf(item.member_id) == -1) {
            this.users.push({ id: item.member_id, name: item.member_name, number: item.member_number })
          }
        })
        // this.users.push({ id: row.person_id, name: row.person })
      }
      this.centerDialogVisible = true;
    },
    async remoteMethod(query, isConcat = false) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: this.$until.getPostsType([4])
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        if (isConcat) {
          this.users = this.users.concat(res.data.data);
        } else {
          this.users = res.data.data;
        }
      }
      this.loading = false;

    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/safe-check-activity/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.target_id = params.target_id.join(',')
      params.member_ids = params.member_ids.join(',')
      let res = await this.$api.instance.interfaceServer('api/safe-check-activity/create', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      params.target_id = params.target_id.join(',')
      params.member_ids = params.member_ids.join(',')
      let res = await this.$api.instance.interfaceServer(`api/safe-check-activity/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
